




















































































































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeApprovisionnement, {ApprovisionnementFilter} from '@/stores/modules/approvisionnement';
import storeClient from "@/stores/modules/client";

import InputDateFilter from '@/components/Input/DateFilter.vue';
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudFournisseurSearch from "@/components/Crud/Fournisseur/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursVente from "@/components/Input/LongueursVente.vue";
import {DateFilterMode} from "@/shared/filter";
import storeFournisseur from "@/stores/modules/fournisseur";
import storeBoisType from '@/stores/modules/boisType';
import storeLongueursVente from '@/stores/modules/longueursVente';
import storePile from "@/stores/modules/pile";

@Component({
	components: {
		InputDateFilter,
		CrudClientSearch,
		InputBoisType,
		InputLongueursVente,
		CrudFournisseurSearch,
	}
})
export default class CrudApprovisionnementFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeApprovisionnement) private page!: number;
	@Stored(() => storeApprovisionnement) private filters!: ApprovisionnementFilter;

	private storeFournisseur = storeFournisseur
	private storeBoisType = storeBoisType

	private valueFournisseur = null;
	private valueBoisType = null;
	private valueLongueursVente = null;
	private valuePile = null;

	@WatchObjectProperties('filters', ApprovisionnementFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeApprovisionnement.dispatch('getC', { filters: true });
	}

	public async mounted(): Promise<void> {
		await storeFournisseur.dispatch('getAll');
		this.valueFournisseur = storeFournisseur.state.all.data
		await storeBoisType.dispatch('getAll');
		this.valueBoisType = storeBoisType.state.all.data
		await storeLongueursVente.dispatch('getAll');
		this.valueLongueursVente = storeLongueursVente.state.all.data
		await storePile.dispatch('getAll');
		this.valuePile = storePile.state.all.data
		this.typeWatcher();
		this.filters = new ApprovisionnementFilter();
		var dt = new Date();
		dt.setDate(dt.getDate() - 90);
		this.filters.date.start = dt;
		this.filters.date.end = new Date();
		this.filters.date.mode = DateFilterMode.RANGE;
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
